import { render, staticRenderFns } from "./license.vue?vue&type=template&id=6e6393c9&scoped=true&"
import script from "./license.vue?vue&type=script&lang=js&"
export * from "./license.vue?vue&type=script&lang=js&"
import style0 from "./license.vue?vue&type=style&index=0&id=6e6393c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6393c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6393c9')) {
      api.createRecord('6e6393c9', component.options)
    } else {
      api.reload('6e6393c9', component.options)
    }
    module.hot.accept("./license.vue?vue&type=template&id=6e6393c9&scoped=true&", function () {
      api.rerender('6e6393c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/license/license.vue"
export default component.exports